import { render } from "./x-segment-control.vue?vue&type=template&id=749e0a0b&scoped=true"
import script from "./x-segment-control.vue?vue&type=script&lang=js"
export * from "./x-segment-control.vue?vue&type=script&lang=js"

import "./x-segment-control.vue?vue&type=style&index=0&id=749e0a0b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-749e0a0b"]])

export default __exports__